import { render } from "./Alcadas.vue?vue&type=template&id=e8fa5aae&scoped=true"
import script from "./Alcadas.vue?vue&type=script&lang=js"
export * from "./Alcadas.vue?vue&type=script&lang=js"

import "./Alcadas.vue?vue&type=style&index=0&id=e8fa5aae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8fa5aae"]])

export default __exports__